import { graphql } from '../../../gql';

// TRIL-305: authored as a codegen graphql() op (not Apollo's untyped `gql`) so a
// dropped selection — e.g. the top-level `id` whose absence caused TRIL-304 —
// becomes a `tsc` error at every typed consumer (UserHydrationGate reads
// `data.getUser.id`). Selection set is unchanged from the prior `gql` version.
export const GET_USER_QUERY = graphql(`
    query getUser($userId: String!) {
        getUser(userId: $userId) {
            id
            interests
            newUser
            lastActive
            username
            firstName
            lastName
            email
            country
            zipPostalCode
            role
            active
            avatar
            bio
            createdAt
            posts {
                id
                textBlocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                textBlocksVersions {
                    blocks {
                        id
                        type
                        data {
                            paragraph
                            header
                            level
                            items{
                                id
                                text
                            }
                            file {
                                url
                            }
                            code
                            withBorder
                            withBackground
                            stretched
                            caption
                            style
                        }
                    }
                    id
                }
                author {
                    bio
                    username
                }
                postAnalytics {
                    id
                    author {
                        username
                        userId
                    }
                    metrics {
                        replies
                        votes {
                            upVotes
                            downVotes
                        }
                        hidden
                        reportedPost {
                            reportedTimes
                            causes
                        }
                        votesCount {
                            upVotes
                            downVotes
                        }
                        replyCount
                        repostCount
                        bookmarkCount
                    }
                }
                article
                createdAt
                updatedAt
                # Viewer-specific fields
                viewerInteractions {
                    hasLiked
                    hasReposted
                    hasBookmarked
                }
            },
            authorReputation {
                sentiment
                volatilityIndex
                metrics {
                    posts
                    following
                    followers
                }
            }
            reputation {
                overallScore
                vouchBoost
                confidence
                source
                lastUpdated
                domains
                dimensionScores {
                    engagement consistency diversityInclusivity behavioralAnalysis
                    communityImpact contentQuality innovativeness expertise
                }
                dimensionConfidences {
                    engagement consistency diversityInclusivity behavioralAnalysis
                    communityImpact contentQuality innovativeness expertise
                }
                evidence {
                    engagement consistency diversityInclusivity behavioralAnalysis
                    communityImpact contentQuality innovativeness expertise
                }
            }
            userProfile {
                isPublicPerson
                displayName
                professionalContext {
                    expertiseAreas
                    educationLevel
                    currentProgram
                    fieldOfStudy
                    institution
                    jobTitle
                    yearsExperience
                    credentials {
                        id
                        title
                        issuer
                        year
                        expiryYear
                        link
                    }
                    updatedAt
                }
            }
            userPreferences {
                theme
                landingPage
                avatarUrl
                planCNudgeDismissedAt
                planCNudgeDismissCount
                planCPromptDismissCount
                planCOptedOut
                navCollapsed
            }
            upVotedPosts
            downVotedPosts
        }
    }
`);
